var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagelist"},[_c('div',{staticStyle:{"text-align":"right"}},[_c('el-pagination',{attrs:{"background":"","page-count":_vm.pages,"current-page":_vm.pageNum,"layout":"prev, pager, next","total":_vm.total,"page-size":_vm.pageSize},on:{"current-change":_vm.pageCurrentChange}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24a4e145","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assessment/pagelist.vue
// module id = null
// module chunks = 